<template>
    <div>
        <GenericPopups ref="GenericPopups" v-if="this.$route.name !== 'login'"></GenericPopups>
        <router-view></router-view>
    </div>
</template>

<script>
import axios from 'axios';
import store from './store';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import {AUTH_REFRESH, AUTH_LOGOUT, OVERRIDE} from './store/actions';
import router from '@/router';
import GenericPopups from '@/components/GenericPopups';

export default {
    name: 'app',
    data() {
        return {
            'store': store,
            refreshing: false,
            refreshGroup: [],
            lastURL: null,
        };
    },
    components: {
        GenericPopups: GenericPopups,
    },
    created: function () {
        let vm = this;

        // handle 401 Unauthorized responses
        const refreshAuthLogic = (failedRequest) => {

            return new Promise((resolve, reject) => {
                //if(failedRequest.response.config.headers['Authorization'] != axios.defaults.headers.common['Authorization']) {
                if(this.refreshing === 2) { //fail all state (failure after auth_reset fail, but before dispatch, rare error!!
                    return reject(failedRequest);
                } else if(this.refreshing){
                    this.refreshGroup.push({failedRequest: failedRequest, resolve: resolve, reject: reject});
                } else if(!axios.defaults.headers.common['Authorization']) {
                    return reject(failedRequest);
                }
                else if(failedRequest.response.config.headers['Authorization'] != axios.defaults.headers.common['Authorization']) {
                    failedRequest.response.config.headers['Authorization'] = axios.defaults.headers.common['Authorization'];
                    return resolve(failedRequest);
                }
                else {
                    this.refreshing = true;
                    vm.$store.dispatch(AUTH_REFRESH).then(() => {
                        const access_token = localStorage.getItem('access-token');

                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
                        failedRequest.response.config.headers['Authorization'] = 'Bearer ' + access_token;

                        vm.$toasted.show('Auth refresh!!');
                        for(let i = 0; i < this.refreshGroup.length; i++) {
                            let childFailedRequest = this.refreshGroup[i].failedRequest;
                            childFailedRequest.response.config.headers['Authorization'] = axios.defaults.headers.common['Authorization'];
                            this.refreshGroup[i].resolve(childFailedRequest);
                        }
                        this.refreshGroup = [];
                        this.refreshing = false;
                        return resolve(failedRequest);
                    }).catch((err) => {
                        for(let i = 0; i < this.refreshGroup.length; i++) {
                            let childFailedRequest = this.refreshGroup[i].failedRequest;
                            this.refreshGroup[i].reject(childFailedRequest);
                        }
                        this.refreshGroup = [];
                        this.refreshing = 2; //to handle a rare error state. where the next dispatch isn't called yet but another failed request came in
                        vm.$store.dispatch(AUTH_LOGOUT).then(() => {
                            this.lastURL = vm.$route.fullPath;
                            vm.$router.push('/login');

                            for(let i = 0; i < this.refreshGroup.length; i++) {
                                let childFailedRequest = this.refreshGroup[i].failedRequest;
                                this.refreshGroup[i].reject(childFailedRequest);
                            }
                            this.refreshGroup = [];
                            this.refreshing = false;
                        }).catch(e => {
                            //calling endpoint is broken for some reason, huge override.
                            this.lastURL = vm.$route.fullPath;
                            vm.$router.replace('/logout');

                            for(let i = 0; i < this.refreshGroup.length; i++) {
                                let childFailedRequest = this.refreshGroup[i].failedRequest;
                                this.refreshGroup[i].reject(childFailedRequest);
                            }
                            this.refreshGroup = [];
                            this.refreshing = false;
                        }).finally((e) => {
                            this.$parent.$bvModal.msgBoxOk("Session has expired, you have been logged out.", {
                                title: "Logout Notification",
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                            reject(err);
                        });
                    });
                }
            });
        };

        createAuthRefreshInterceptor(vm.$http, refreshAuthLogic);

        // add in proper config response when needed
        axios.interceptors.request.use(function (config) {
            //console.log("CONFIGURATION", config);
            let endpoints = vm.$store.getters.overideEndpoints;
            //console.log("PRELOAD", config, endpoints, endpoints.length);
            for (let i = 0; i < endpoints.length; i++) {
                if(config.url.indexOf(endpoints[i]) != -1) {
                    config.headers['overrider-id'] = vm.$store.getters.overrideID;
                    config.headers['overridden-permission'] = vm.$store.getters.overridePermission;
                    vm.$store.commit(OVERRIDE, null);
                    break;
                }
            }

            return config;
        }, function (error) {
            // Do something with request error
            return Promise.reject(error);
        });

        //react to somethign that happened
        axios.interceptors.response.use(
            (res) => {
                return res;
            },
            (err) => {
                let res = err.response;
                let message = '';

                if (res &&  res.data && res.data.message) {
                    message = res.data.message;
                }
                if(res && res.data) {
                    if (res.data.showPopup) {
                        let title = res.data.title || 'Issue Updating Data';
                        this.$parent.$bvModal.msgBoxOk(message, {
                            title: title,
                            size: 'md',
                            buttonSize: 'sm',
                            okVariant: 'danger',
                            headerClass: 'p-2 border-bottom-0 text-center d-block',
                            footerClass: 'p-2 border-top-0',
                        });
                    } else if (res.data.showPermission) {
                        return new Promise((resolve, reject) => {
                            this.$refs.GenericPopups.displayPermission =
                                {
                                    title: 'Permission denied',
                                    permission: res.data.permission,
                                    text: message || ('Action was denied, request override for ' + res.data.permission),
                                    ok: 'Manager Override', //manager override will do function
                                    cancel: 'Cancel', //cancel is a 'ok'
                                    okAction: function () {/* call again */
                                        resolve(axios.request(err.config));
                                    },
                                    onClose: function () {
                                        reject(err);
                                    }
                                };
                        });
                    } else if (res.status != 401 && res.status != 404) { //401 is unauthorized, we only want unexpected fall threw errors
                        console.log(res);
                        if (message) {
                            this.$parent.$bvModal.hide('alert_id');
                            this.$parent.$bvModal.msgBoxOk(message, {
                                id: 'alert_id',
                                title: "Error",
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                        }
                        else
                        {
                            this.$parent.$bvModal.msgBoxOk('Unknown Error (No message From Server)', {
                                title: "Server Error",
                                id: 'alert_id',
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                headerClass: 'p-2 border-bottom-0 text-center d-block',
                                footerClass: 'p-2 border-top-0',
                            });
                        }
                    } else if (res.status == 404) {
                        const h = vm.$createElement;
                        const vNodesMsg = h(
                            'div',
                            { class: 'd-flex align-items-center' },
                            [
                                h('div',
                                    { class: 'mr-2' },
                                    [
                                        h('i', { class: 'fa-duotone fa-exclamation-triangle fa-fw fa-2x fa-pull-left text-warning' }, ''),
                                    ]
                                ),
                                h('div',
                                    [
                                        h('strong', 'Not Found'),
                                        h('div', { class: 'font-xs' }, `${message || 'The requested resource was not found.'}`)
                                    ]
                                ),
                            ],
                        );
                        vm.$bvToast.toast([vNodesMsg], {
                            variant: 'secondary',
                            toaster: 'b-toaster-bottom-right',
                            toastClass: 'w-100',
                            noCloseButton: true,
                        });
                    }
                } else if (err.toString().indexOf("Operation canceled due to new request") !== -1) {
                    console.log('Response was canceled!');
                } else if (!this.$http.isCancel(err)) {
                    const h = vm.$createElement;
                    const vNodesMsg = h(
                        'div',
                        { class: 'd-flex align-items-center' },
                        [
                            h('div',
                                { class: 'mr-2' },
                                [
                                    h('i', { class: 'fa-duotone fa-exclamation-triangle fa-fw fa-2x fa-pull-left text-danger' }, ''),
                                ]
                            ),
                            h('div',
                                [
                                    h('strong', 'Error'),
                                    h('div', { class: 'font-xs' }, `${err}`)
                                ]
                            ),
                        ],
                    );
                    vm.$bvToast.toast([vNodesMsg], {
                        variant: 'secondary',
                        toaster: 'b-toaster-bottom-right',
                        toastClass: 'w-100',
                        noCloseButton: true,
                    });
                }
                return Promise.reject(err);
            }
        );

        // Route directly to the order in certain areas if an order is loaded
        router.beforeEach((to, from, next) => {
            this.$store.commit('commitFlag', null);
            if (this.$store.getters.activeOrder) {
                let order_id = this.$store.getters.activeOrder.id;
                let toSplit = to.fullPath.split('/').filter((e)=>{return e;});
                let fromSplit = from.fullPath.split('/').filter((e)=>{return e;});
                if(!toSplit || !fromSplit || toSplit[0] != fromSplit[0]){
                    switch (to.name) {
                        case 'appraisals-scan':
                            if(this.$store.getters.activeOrder.status_id < 5) {
                                next({path: '/appraisals/process/' + order_id});
                            } else {
                                next({path: '/appraisals/appraise/' + order_id});
                            }
                            break;
                        case 'quality-assurance-scan':
                            next({path: '/quality-assurance/view/' + order_id});
                            break;
                        case 'offer-generation-scan':
                            next({path: '/offer-generation/view/' + order_id});
                            break;
                        case 'returns-scan':
                            next({path: '/returns/view/' + order_id});
                            break;
                        default:
                            if (to.path === '/kit/view') {
                                next({path: '/kit/view/' + order_id});
                            }
                            next();
                            // Unset any active order record from Vuex
                            if (this.$store.getters.activeOrder && to.name !== 'kit-view-index') {
                                this.$store.commit('setActiveOrder', null);
                            }
                    }
                } else {
                    next();
                }
            } else {
                next();
            }
        });

    }
};
</script>

<style lang="scss">
/* Import App Styles */
@import 'assets/scss/style';
</style>
